/******************************************************************************************
 * Javascript methods for the _Layout
 ******************************************************************************************/

import { TaxInfo } from './_Shared.js';

TaxInfo._Layout = {

    Init: function () {
        /// <summary>
        /// Page Initialization for the _Layout.vbhtml view
        /// </summary>

        // wire up search box
        $("#SearchForm").on("submit", function () {
            window.location.href = "/Search/" + $("#SearchText").val();
            return false;
        });

        // wire up restore user link
        $("#restoreUser").on("click", function () {
            TaxInfo._Layout.restoreUser();
            return false;
        });


        $("body").removeClass("prevent-animation");
    }
    , restoreUser: function () {
        $.post("/User/Restore").always(
                function () {
                    window.location.reload();
                });
    }

}
